import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const MyPresetTwo = definePreset(Lara, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          0: '#ffffff',
          50: '{slate.100}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
      dark: {
        primary: {
          0: '#ffffff',
          50: '{slate.250}',
          100: '{slate.200}',
          200: '{slate.200}',
          300: '{slate.400}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.200}',
          950: '{slate.50}',
        },
      },
    },
  },
});
